import { apiService } from './api.service';
import type {
  Diagram,
  CreateDiagramDto,
  UpdateDiagramDto,
} from '../../../shared/src/types/space.types';

/**
 * Service for diagram API operations
 */
class DiagramsService {
  /**
   * Get all diagrams for a space
   */
  async getAll(spaceId: string): Promise<Diagram[]> {
    return await apiService.get<Diagram[]>(`/diagrams/space/${spaceId}`);
  }

  /**
   * Get a single diagram by ID
   */
  async getOne(id: string): Promise<Diagram> {
    return await apiService.get<Diagram>(`/diagrams/${id}`);
  }

  /**
   * Create a new diagram
   */
  async create(data: CreateDiagramDto): Promise<Diagram> {
    return await apiService.post<Diagram>('/diagrams', data);
  }

  /**
   * Update a diagram
   */
  async update(id: string, data: UpdateDiagramDto): Promise<Diagram> {
    return await apiService.put<Diagram>(`/diagrams/${id}`, data);
  }

  /**
   * Delete a diagram
   */
  async delete(id: string): Promise<void> {
    return await apiService.delete(`/diagrams/${id}`);
  }

  /**
   * Update diagram thumbnail
   */
  async updateThumbnail(id: string, thumbnail: string): Promise<Diagram> {
    return await apiService.put<Diagram>(`/diagrams/${id}/thumbnail`, {
      thumbnail,
    });
  }
}

export default new DiagramsService();
